import { onReady } from './dom.js';

var DATE_RE = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/;

onReady(function () {
    var form = document.querySelector('form#filtering');
    var custom = document.getElementById('date-custom');
    var picker = document.getElementById('date-custom-picker');
    var state = document.getElementById('date-custom-state');
    var start = document.getElementById('date-custom-start');
    var end = document.getElementById('date-custom-end');
    var apply = document.getElementById('date-custom-apply');
    var error = document.getElementById('date-custom-error');

    function openPicker(open) {
        if (!picker) {
            return;
        }
        // Visibility only: aria-expanded is not a valid attribute on role=radio, and the
        // picker is a labelled group that follows the radio in DOM order.
        picker.classList.toggle('hidden', !open);
    }

    if (form) {
        form.addEventListener('change', function (event) {
            // Typing a date fires `change`, and a range is only valid once BOTH bounds are
            // set, so the picker submits through its own Apply button instead.
            if (picker && picker.contains(event.target)) {
                return;
            }

            if (event.target === custom) {
                // Submitting here would send `date=custom` with no bounds, which the guards
                // in widget.twig and SearchQuery reject -- bouncing straight back to the
                // default window. Reveal the picker and wait for Apply. See #285.
                openPicker(true);
                if (start) {
                    start.focus();
                }
                return;
            }

            // A Date preset replaces any applied range, so its bounds go with it.
            if (state && event.target.name === 'date' && event.target.type === 'radio') {
                state.innerHTML = '';
                openPicker(false);
            }

            submitForMatomo(form);
        });
    }

/**
     * Submit the filter form in a way Matomo can see.
     *
     * `form.submit()` does not dispatch a `submit` event -- that is the documented difference
     * between it and a real submission -- so Matomo FormAnalytics never saw any of these.
     * Last 30 days the `filtering` form reported 2,325 viewers, 208 starters and **4**
     * submitters, and the four were keyboard submissions that went through the browser's own
     * path rather than this code. It read as catastrophic drop-off and was a measurement
     * artefact. See #420.
     *
     * `requestSubmit()` dispatches the event. It also runs constraint validation, which
     * `submit()` skips -- safe here because the filter form carries no `required` or
     * `pattern` attributes, and its date bounds are validated by hand above before we ever
     * get here.
     *
     * It is Safari 16, and the floor pinned in package.json and vite.config.mjs is Safari 13,
     * so older browsers keep the old path. The alternative was dispatching a synthetic submit
     * event before `submit()`, and that is rejected deliberately: a synthetic event also
     * reaches every document-level listener, including submit-once.js, so it would change
     * behaviour for real users in order to improve a number. Under-counting iOS 13-15 is the
     * cheaper error, and it shrinks on its own.
     */
    function submitForMatomo(form) {
        if (typeof form.requestSubmit === 'function') {
            form.requestSubmit();
            return;
        }

        form.submit();
    }

    function fail(message) {
        if (error) {
            error.textContent = message;
            error.classList.remove('hidden');
        }
    }

    if (apply && form && state && start && end && custom) {
        apply.addEventListener('click', function () {
            if (error) {
                error.classList.add('hidden');
            }

            // The visible inputs carry no `name`: nothing is submitted until both bounds pass,
            // so a half-entered range can't silently reset the filter.
            if (!DATE_RE.test(start.value) || !DATE_RE.test(end.value)) {
                fail('Choose both a start date and an end date.');
                return;
            }

            if (end.value < start.value) {
                fail('The end date must be on or after the start date.');
                return;
            }

            custom.checked = true;
            state.innerHTML = '';
            [['date-custom-start', start.value], ['date-custom-end', end.value]].forEach(function (pair) {
                var input = document.createElement('input');
                input.type = 'hidden';
                input.name = pair[0];
                input.value = pair[1];
                state.appendChild(input);
            });

            submitForMatomo(form);
        });
    }
});
